import { icons } from '@chillibean/component-library/legacy';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams, Link } from 'react-router-dom';

import { useAppContext } from '../../../../../context/AppContext';
import HeroBox from '../../../../../HeroBox/HeroBox';
import Button from '../../../../../primitives/form/button/Button';
import {
  duplicateFormTemplate,
  toggleFormTemplateActive,
  setFormTemplatesError,
} from '../../redux/actions/formTemplateApiActions';
import { handleFormTemplateFailure, handleFormTemplateSuccess } from '../../utils/formTemplateNotifications';
import { filterFormTemplatesByActive } from '../../utils/utils';
import FormTemplateList from './FormTemplateList';

function CreateFormTemplateBox() {
  const heroHeaderTitles = [
    {
      title: 'FORMS:',
      subTitle: 'Template Builder',
    },
  ];
  return (
    <HeroBox
      backgroundIcon="fa-list-ul"
      headerIcon={{ isSVG: true, headerIcon: icons.noteWithPencil }}
      headerTitles={heroHeaderTitles}
      displayBoxShadow
    >
      <p>
        Form Templates are a versatile tool to gather information from your end users. Form Templates are controlled by
        user permissions and allocated to specific Libraries to help you create a tailored workflow. Form data can be
        collated, downloaded and used to track the progress of your clinical trial.
      </p>

      <Link to="/new">
        <Button
          name="CREATE NEW FORM TEMPLATE"
          buttonType="primary"
          elementType="button"
          dataTestId="create-new-form-template-button"
        />
      </Link>
    </HeroBox>
  );
}

function HomepageContainer(props) {
  const {
    formTemplates,
    formTemplateAllIds,
    formTemplateRequest,
    duplicateFormTemplateConnect,
    toggleFormTemplateActiveConnect,
    setFormTemplatesErrorConnect,
  } = props;

  const { notificationDomRef } = useAppContext();
  const { displaytype } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const { requestType, loading } = formTemplateRequest;

  const handleDuplicate = async (formTemplateId) => {
    if (isLoading) return;

    try {
      setIsLoading(true);
      await duplicateFormTemplateConnect(formTemplateId);
      handleFormTemplateSuccess(notificationDomRef, setFormTemplatesErrorConnect, 'duplicateTemplate');
    } catch (error) {
      handleFormTemplateFailure(error, notificationDomRef, setFormTemplatesErrorConnect, 'duplicateTemplate');
    } finally {
      setIsLoading(false);
    }
  };

  const handleActiveToggle = async (formTemplateId, active, reasonForChange) => {
    if (isLoading) return;
    try {
      setIsLoading(true);
      await toggleFormTemplateActiveConnect(formTemplateId, active, reasonForChange);
      handleFormTemplateSuccess(
        notificationDomRef,
        setFormTemplatesErrorConnect,
        'activeToggleTemplate',
        `Form Template is ${active ? 'active' : 'inactive'}`,
      );
    } catch (error) {
      handleFormTemplateFailure(error, notificationDomRef, setFormTemplatesErrorConnect, 'activeToggleTemplate');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      if (requestType) setFormTemplatesErrorConnect({}, null);
    };
  }, [requestType]);

  const homeDisplayController = () => {
    return (
      <div className="template-builder_content-wrapper">
        <CreateFormTemplateBox />
        <FormTemplateList
          formTemplates={filterFormTemplatesByActive(formTemplates, displaytype)}
          formTemplateAllIds={formTemplateAllIds}
          formTemplateRequestLoading={loading}
          onDuplicate={handleDuplicate}
          onConfirmActiveToggle={handleActiveToggle}
        />
      </div>
    );
  };
  return <div>{homeDisplayController()}</div>;
}

function mapStateToProps(state) {
  return {
    formTemplates: state.formTemplateApiReducer.formTemplates,
    formTemplateAllIds: state.formTemplateApiReducer.formTemplateAllIds,
    formTemplateRequest: state.formTemplateApiReducer.formTemplateRequest,
  };
}

const mapDispatchToProps = {
  duplicateFormTemplateConnect: duplicateFormTemplate,
  toggleFormTemplateActiveConnect: toggleFormTemplateActive,
  setFormTemplatesErrorConnect: setFormTemplatesError,
};

HomepageContainer.propTypes = {
  formTemplates: PropTypes.shape({}).isRequired,
  formTemplateAllIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  formTemplateRequest: PropTypes.shape({
    error: PropTypes.shape({}),
    loading: PropTypes.bool,
    requestType: PropTypes.string,
  }).isRequired,
  duplicateFormTemplateConnect: PropTypes.func.isRequired,
  toggleFormTemplateActiveConnect: PropTypes.func.isRequired,
  setFormTemplatesErrorConnect: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(HomepageContainer);
